import { CampaignStatus } from '../types/campaign';

/**
 * Campaign Status Color Scheme
 *
 * Aligned with platform conventions:
 * - completed/success = green
 * - active = blue (in progress)
 * - paused = yellow (warning)
 * - draft/archived = neutral (inactive)
 */

export const CAMPAIGN_STATUS_COLORS: Record<CampaignStatus, {
  bg: string;
  text: string;
  dot: string;
  textOnly: string;  // For simple text-only display
}> = {
  draft: {
    bg: 'bg-neutral-100',
    text: 'text-neutral-600',
    dot: 'bg-neutral-400',
    textOnly: 'text-neutral-400',
  },
  active: {
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    dot: 'bg-blue-500',
    textOnly: 'text-blue-600',
  },
  paused: {
    bg: 'bg-yellow-50',
    text: 'text-yellow-700',
    dot: 'bg-yellow-500',
    textOnly: 'text-yellow-600',
  },
  completed: {
    bg: 'bg-green-50',
    text: 'text-green-700',
    dot: 'bg-green-500',
    textOnly: 'text-green-600',
  },
  archived: {
    bg: 'bg-neutral-100',
    text: 'text-neutral-500',
    dot: 'bg-neutral-400',
    textOnly: 'text-neutral-400',
  },
};

export const CAMPAIGN_STATUS_LABELS: Record<CampaignStatus, string> = {
  draft: 'Draft',
  active: 'Active',
  paused: 'Paused',
  completed: 'Completed',
  archived: 'Archived',
};

/**
 * Get status style for text-only display (simple colored text)
 */
export const getCampaignStatusStyle = (status: string): string => {
  const colors = CAMPAIGN_STATUS_COLORS[status as CampaignStatus];
  return colors?.textOnly || 'text-neutral-400';
};

/**
 * Get status label with proper capitalization
 */
export const getCampaignStatusLabel = (status: string): string => {
  const label = CAMPAIGN_STATUS_LABELS[status as CampaignStatus];
  return label || status.charAt(0).toUpperCase() + status.slice(1);
};
